import '../App.css';
import { useState } from 'react';
import axios from 'axios';
import Banner from '../components/Banner';
import Loading from '../components/Loading';
import TitleComponent from '../components/TitleComponent';
import Footer from '../components/Footer';

function AdminCoupon() {
    const [isLoading, setIsLoading] = useState(false);
    const [password, setPassword] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [excludeUsed, setExcludeUsed] = useState(false);
    const [promoCodes, setPromoCodes] = useState([]);
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [newPromoCode, setNewPromoCode] = useState({
        code: '',
        discountAmount: 3900,
        leftCode: 1,
    });

    // Fetch promo codes
    const fetchPromoCodes = () => {
        if (!password) {
            alert('비밀번호를 입력해주세요.');
            return;
        }

        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_ADDRESS}/promo_codes`;
        const params = new URLSearchParams({
            bananaSecretKey: password,
        });

        if (excludeUsed) {
            params.append('exceptLeftZero', 'true');
        }

        axios
            .get(`${url}?${params}`)
            .then((res) => {
                setPromoCodes(res.data.promoCodes || []);
                setIsAuthenticated(true);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                if (error.response?.status === 403) {
                    alert('비밀번호가 올바르지 않습니다.');
                    setIsAuthenticated(false);
                } else {
                    alert('프로모 코드를 불러오는데 실패했습니다.');
                }
            });
    };

    // Create promo code
    const createPromoCode = () => {
        if (!newPromoCode.code.trim()) {
            alert('프로모 코드를 입력해주세요.');
            return;
        }

        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_ADDRESS}/create_promo_code`;
        const data = {
            code: newPromoCode.code,
            discountAmount: parseInt(newPromoCode.discountAmount),
            leftCode: parseInt(newPromoCode.leftCode),
            bananaSecretKey: password,
        };
        const config = { headers: { 'Content-Type': 'application/json' } };

        axios
            .post(url, data, config)
            .then((res) => {
                alert('프로모 코드가 생성되었습니다.');
                setNewPromoCode({
                    code: '',
                    discountAmount: 3900,
                    leftCode: 1,
                });
                setIsAddingNew(false);
                fetchPromoCodes();
            })
            .catch((error) => {
                setIsLoading(false);
                if (error.response?.status === 409) {
                    alert('이미 존재하는 프로모 코드입니다.');
                } else if (error.response?.status === 403) {
                    alert('비밀번호가 올바르지 않습니다.');
                } else {
                    alert('프로모 코드 생성에 실패했습니다.');
                }
            });
    };

    // Delete promo code
    const deletePromoCode = (code) => {
        if (!window.confirm(`'${code}' 프로모 코드를 삭제하시겠습니까?`)) {
            return;
        }

        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_ADDRESS}/delete_promo_code`;
        const data = {
            code: code,
            bananaSecretKey: password,
        };
        const config = { headers: { 'Content-Type': 'application/json' } };

        axios
            .delete(url, { ...config, data: data })
            .then((res) => {
                alert('프로모 코드가 삭제되었습니다.');
                fetchPromoCodes();
            })
            .catch((error) => {
                setIsLoading(false);
                if (error.response?.status === 404) {
                    alert('프로모 코드를 찾을 수 없습니다.');
                } else if (error.response?.status === 403) {
                    alert('비밀번호가 올바르지 않습니다.');
                } else {
                    alert('삭제에 실패했습니다.');
                }
            });
    };

    const passwordInputDiv = () => {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '20px',
                }}
            >
                <input
                    className="custom-input-text"
                    type="password"
                    value={password}
                    placeholder="관리자 비밀번호"
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            fetchPromoCodes();
                        }
                    }}
                    style={{ maxWidth: '300px' }}
                />
                <button
                    onClick={fetchPromoCodes}
                    style={{ fontSize: '15px', padding: '10px 20px' }}
                >
                    확인
                </button>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <input
                        id="exclude-used"
                        type="checkbox"
                        checked={excludeUsed}
                        onChange={(e) => setExcludeUsed(e.target.checked)}
                    />
                    <label htmlFor="exclude-used" style={{ margin: 0 }}>
                        사용한 코드 제외
                    </label>
                </div>
            </div>
        );
    };

    const promoCodeListDiv = () => {
        return (
            <>
                <div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px',
                        }}
                    >
                        <div className="table-title">프로모 코드 목록</div>
                        <button
                            onClick={() => {
                                setIsAddingNew(true);
                                setNewPromoCode({
                                    code: '',
                                    discountAmount: 3900,
                                    leftCode: 1,
                                });
                            }}
                            style={{
                                fontSize: '20px',
                                padding: '5px 15px',
                                minWidth: '40px',
                            }}
                        >
                            +
                        </button>
                    </div>

                    {isAddingNew && (
                        <div
                            style={{
                                border: '2px solid #ff7b07',
                                borderRadius: '5px',
                                padding: '15px',
                                marginBottom: '20px',
                            }}
                        >
                            <div className="input-field">
                                <div className="input-info">
                                    <label>코드</label>
                                </div>
                                <input
                                    className="custom-input-text"
                                    type="text"
                                    value={newPromoCode.code}
                                    placeholder="프로모 코드 입력"
                                    onChange={(e) =>
                                        setNewPromoCode({
                                            ...newPromoCode,
                                            code: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            <div className="input-field">
                                <div className="input-info">
                                    <label>할인 금액</label>
                                </div>
                                <input
                                    className="custom-input-text"
                                    type="number"
                                    value={newPromoCode.discountAmount}
                                    onChange={(e) =>
                                        setNewPromoCode({
                                            ...newPromoCode,
                                            discountAmount: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            <div className="input-field">
                                <div className="input-info">
                                    <label>사용 가능 횟수</label>
                                </div>
                                <input
                                    className="custom-input-text"
                                    type="number"
                                    value={newPromoCode.leftCode}
                                    onChange={(e) =>
                                        setNewPromoCode({
                                            ...newPromoCode,
                                            leftCode: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    gap: '10px',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <button
                                    onClick={() => setIsAddingNew(false)}
                                    className="white-button"
                                    style={{ fontSize: '15px', padding: '8px 15px' }}
                                >
                                    취소
                                </button>
                                <button
                                    onClick={createPromoCode}
                                    style={{ fontSize: '15px', padding: '8px 15px' }}
                                >
                                    확인
                                </button>
                            </div>
                        </div>
                    )}

                    {promoCodes.length === 0 ? (
                        <div
                            className="info-title"
                            style={{ textAlign: 'center', padding: '20px' }}
                        >
                            등록된 프로모 코드가 없습니다.
                        </div>
                    ) : (
                        promoCodes.map((promo, index) => (
                            <div
                                key={index}
                                className="justify-content-space-between"
                                style={{
                                    marginBottom: '15px',
                                    padding: '15px',
                                    border: '1px solid #ddd',
                                    borderRadius: '5px',
                                }}
                            >
                                <div>
                                    <div className="orange-info-title">
                                        {promo.code}
                                    </div>
                                    <div className="info-info">
                                        할인 금액: {promo.discountAmount}원
                                    </div>
                                    <div className="info-info">
                                        남은 횟수: {promo.leftCode}회
                                    </div>
                                    <div className="info-info">
                                        상태:{' '}
                                        {promo.available ? '사용 가능' : '사용 불가'}
                                    </div>
                                </div>
                                <button
                                    onClick={() => deletePromoCode(promo.code)}
                                    style={{
                                        fontSize: '18px',
                                        padding: '5px 15px',
                                        backgroundColor: '#ff4444',
                                    }}
                                >
                                    ✕
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </>
        );
    };

    return (
        <div>
            {isLoading ? (
                <Loading />
            ) : (
                <div className="app">
                    <div className="border-padding">
                        <TitleComponent subtitle={'쿠폰 관리'} />
                        <div className="page-content">
                            {!isAuthenticated ? (
                                <Banner
                                    bannerTitle={'관리자 인증'}
                                    contentDiv={passwordInputDiv()}
                                />
                            ) : (
                                <Banner
                                    bannerTitle={'프로모 코드 관리'}
                                    contentDiv={promoCodeListDiv()}
                                />
                            )}
                        </div>
                    </div>
                    <Footer />
                </div>
            )}
        </div>
    );
}

export default AdminCoupon;
